import { ICellRendererParams } from 'ag-grid-community';
import React from 'react';
import Config from '../../../config';
import Avatar from '../avatar.component';
import { GroupAvatarIcon } from '../../../icon';

interface Props extends ICellRendererParams {
    SetName: string;
    ShowBadgeIcon: boolean;
    HideAvatar?: boolean;
    onClick?: () => void;
    PhoneNumber?: string;
    Icon?: any;
}

export const AvatarRenderer = (props: Props) => {
    return (
        <span className='d-flex' onClick={props.onClick}>
            {props.HideAvatar ===false && <div className='my-auto p-relative'>
                <Avatar
                    Name={props.SetName}
                    className="avatar my-auto mr-2 h6-regular"
                    ImgSrc={!!props.Icon ? props.Icon : props.data.ImageReferenceID ? `${Config.API_URL}/api/File/${props.data.ImageReferenceID}/view` : ""}
                    Size={28}
                    Index={props.rowIndex}
                    PhoneNumber={props.PhoneNumber}
                />
                {!!props.ShowBadgeIcon && <GroupAvatarIcon className="p-absolute t-2 l-2" />}
            </div>}
            <span className='my-auto' style={!props.HideAvatar ? { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' } : null}> {props.value} </span>
        </span>);
};
